import { UiTab } from "./dashboard";

export class UiProfilePage {
    public id: string;
    public tenantId: string;
    public name: string;
    public uiProfileId: string;
    public urlPath: string;
    public informationalBadge: MenuInformationalBadge;
    public userTypeIds: string[];
    public tabs: UiTab[];
    public navigation: UiProfilePageNavigationType;
    public templateName: string;
    public visibilityCondition: string;
    public external: boolean;
    public externalUrl: string;
    public type: UiProfilePageType;
    public showStoreCatalog: boolean;
    public storeCatalogLayoutMode: StoreCatalogLayoutMode;
    public controlBarTemplateName: string;
    public showSubscriptionsCustomers: boolean;
    public showSubscriptionsPartners: boolean;
    public showSubscriptionsDataRecipients: boolean;
    public availabilityFeatures: string[];
    public icon: string;
}

export enum MenuInformationalBadge {
    ALERT_COUNT = 'ALERT_COUNT',
    WORK_SESSION_COUNT = 'WORK_SESSION_COUNT',
    ACTION_COUNT = 'ACTION_COUNT',
    ACTION_COUNT_BY_PRIORITY = 'ACTION_COUNT_BY_PRIORITY',
    ISSUE_COUNT = 'ISSUE_COUNT'
}

export enum UiProfilePageNavigationType {
    SIDEBAR_MENU = 'SIDEBAR_MENU',
    LINK = 'LINK',
    TOPBAR_LEFT = 'TOPBAR_LEFT',
    TOPBAR_RIGHT = 'TOPBAR_RIGHT',
    TOPBAR = 'TOPBAR',
    USER_MENU = 'USER_MENU'
}

export enum UiProfilePageType {
    CUSTOM = 'CUSTOM',
    STORE = 'STORE',
    SUBSCRIPTIONS = 'SUBSCRIPTIONS',
    PAYMENTS = 'PAYMENTS',
    DATA_MANAGEMENT = 'DATA_MANAGEMENT',
    TICKETS = 'TICKETS'
}

export enum StoreCatalogLayoutMode {
    GRID = 'GRID',
    LIST = 'LIST'
}